// extracted by mini-css-extract-plugin
module.exports = {"container":"Image_container__7yy2X","innerContainer":"Image_innerContainer__gISht","picture":"Image_picture__IJF6G"};